import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './vendorApp.component.html',
    styleUrls: ['./vendorApp.component.css'],
})

export class VendorAppComponent implements OnInit {
  constructor(
  ) {}

  ngOnInit() {
  }
}
